import { useLocation } from 'react-router';
import useExpTemplateList from './template/useExpTemplateList';
import { AUTO_GENERATED_OPTION_ID } from '@shared/constants';
import useExpDetailsRouteParams from './useExpDetailsRouteParams';

const useExpDetailsSelectedTemplateId = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const viewIdParam = searchParams.get('viewId');
  const { projectId } = useExpDetailsRouteParams();
  const { data: templateList = [] } = useExpTemplateList();
  const savedTemplateList = templateList.filter(t => !t.personalView);

  if (viewIdParam === AUTO_GENERATED_OPTION_ID) return;

  const selectedTemplateId = savedTemplateList.find(
    temp => temp.templateId === viewIdParam
  )?.templateId;
  const defaultTemplateId = savedTemplateList
    .filter(t => t.projectId === projectId)
    .find(temp => temp.defaultTemplate)?.templateId;

  return selectedTemplateId || defaultTemplateId;
};

export default useExpDetailsSelectedTemplateId;
